// Shared styled components for the Fixed Assets report pages.
import styled from 'styled-components';
import { colors } from '../../theme/colors';

export const FiltersCard = styled.div`
  background: ${colors.background.paper}; border: 1px solid ${colors.border.light};
  border-radius: 10px; padding: 14px 16px; margin-bottom: 16px;
`;
export const FilterGrid = styled.div`display: flex; gap: 16px; align-items: flex-end; flex-wrap: wrap;`;
export const FilterItem = styled.div`display: flex; flex-direction: column; gap: 4px; min-width: 150px;`;
export const FilterLabel = styled.label`font-size: 12px; color: ${colors.text.secondary}; font-weight: 600;`;
export const FilterSelect = styled.select`
  padding: 8px 10px; border: 1px solid ${colors.border.light}; border-radius: 8px; font-size: 14px;
  background: ${colors.background.main}; color: ${colors.text.primary};
`;
export const FilterInputWrap = styled.div`
  display: flex; align-items: center; gap: 6px; padding: 0 10px; border: 1px solid ${colors.border.light};
  border-radius: 8px; color: ${colors.text.secondary};
  input { border: none; outline: none; padding: 8px 0; font-size: 14px; background: transparent; color: ${colors.text.primary}; flex: 1; }
`;
export const ResetBtn = styled.button`
  display: inline-flex; align-items: center; gap: 6px; padding: 8px 14px; height: 38px;
  background: none; border: 1px solid ${colors.border.light}; border-radius: 8px; cursor: pointer; color: ${colors.text.secondary};
  &:hover { border-color: ${colors.primary.main}; color: ${colors.primary.main}; }
`;
export const KPIGrid = styled.div`
  display: grid; grid-template-columns: repeat(auto-fit, minmax(180px, 1fr)); gap: 12px; margin-bottom: 16px;
`;
export const KPI = styled.div`
  padding: 14px 16px; border-radius: 10px; text-align: left;
  background: ${p => p.$highlight ? colors.primary.main : colors.background.paper};
  border: 1px solid ${p => p.$highlight ? colors.primary.main : colors.border.light};
  color: ${p => p.$highlight ? '#fff' : 'inherit'};
`;
export const KL = styled.div`
  font-size: 11px; text-transform: uppercase; letter-spacing: 0.4px; font-weight: 600;
  color: ${p => p.theme && false ? '' : 'inherit'}; opacity: 0.8;
`;
export const KV = styled.div`font-size: 20px; font-weight: 700; margin-top: 4px;`;
export const ToolbarRow = styled.div`
  display: flex; align-items: center; justify-content: space-between; margin-bottom: 12px; gap: 12px; flex-wrap: wrap;
  h3 { font-size: 14px; margin: 0; }
`;
export const ExportBtn = styled.button`
  display: inline-flex; align-items: center; gap: 6px; padding: 8px 14px;
  background: ${colors.background.paper}; border: 1px solid ${colors.border.light}; border-radius: 8px;
  cursor: pointer; color: ${colors.text.secondary}; font-size: 13px;
  &:hover { border-color: ${colors.primary.main}; color: ${colors.primary.main}; }
`;
export const ReportCard = styled.div`
  background: ${colors.background.main}; border: 1px solid ${colors.border.light}; border-radius: 10px;
  padding: 0; overflow-x: auto;
`;
export const RTable = styled.table`
  width: 100%; border-collapse: collapse; font-size: 13px;
  th, td { padding: 10px 12px; border-bottom: 1px solid ${colors.border.light}; text-align: left; white-space: nowrap; }
  th { background: ${colors.background.paper}; color: ${colors.text.secondary}; font-weight: 600; position: sticky; top: 0; }
  td.r, th.r { text-align: right; font-family: 'Consolas', monospace; }
  tbody tr:hover { background: ${colors.background.paper}; }
  tfoot td { font-weight: 700; border-top: 2px solid ${colors.border.main}; background: ${colors.background.paper}; }
`;
export const Loading = styled.div`padding: 40px; text-align: center; color: ${colors.text.secondary};`;
export const Empty = styled.div`padding: 50px 20px; text-align: center; color: ${colors.text.secondary};`;
export const Pill = styled.span`
  padding: 2px 8px; border-radius: 12px; font-size: 11px; font-weight: 700;
  background: ${p => `${p.$color || colors.text.disabled}22`}; color: ${p => p.$color || colors.text.secondary};
`;
